import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { dataRequested, updatePagination, updateUi } from "../common/actions";
import { getExpandState } from "../common/services/Utilities";
import { SearchForm } from "../components/SearchForm";
import { All, Form } from "../interfaces";

export function mapStateToProps({ appState }: All) {
  const expandState = appState?.app
    ? (appState as any)[appState.app]?.ui?.searchPanelExpand
    : undefined;

  return {
    searchPanelExpand: getExpandState(expandState, true),
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    onSubmit: (form: Form, submitted?: boolean) => {
      dispatch(dataRequested());
      Object.keys(form).forEach((filterField) => {
        switch (filterField) {
          case "name":
          case "bhcName":
          case "city":
          case "bhcCity":
          case "stateSearch":
          case "certSearch":
          case "url":
            dispatch(
              actions.updateSearch(filterField, form[filterField] as string),
            );
            break;
          case "branchOffices":
          case "limitEstablishedDate":
          case "limitInactiveDate":
          case "institutionType":
          case "savedPGCSearch":
          case "savedGroupId":
          case "savedReportId":
          case "locations":
          case "reportType":
          case "marketSelection":
          case "institutionTypeTimeSeries":
          case "totalsType":
          case "displayResults":
          case "displayAll":
          case "subOptionsSelected":
            dispatch(
              actions.updateUi(filterField, form[filterField] as string),
            );
            break;
          default:
            dispatch(
              actions.updateFilter(filterField, form[filterField] as string),
            );
            break;
        }
      });
      submitted && dispatch(actions.updateUi("searchPush", submitted));
      dispatch(updatePagination("pageNumber", 1));
      dispatch(actions.searchPush());
    },
    setSearchPanelExpand: (updatedSearchPanelExpand: boolean) => {
      dispatch(updateUi("searchPanelExpand", updatedSearchPanelExpand));
      dispatch(actions.searchPush());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchForm);
